export default __webpack_public_path__ + "assets/objectType/kulturvesturisks_apskates_objekts_VISITED.png";